import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, FormBuilder, NgForm, Validators,FormArray } from '@angular/forms';
import {MyserviceService} from '../myservice.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  providers:[MyserviceService],
})
export class UserComponent implements OnInit {

  constructor(private fb: FormBuilder,private serv:MyserviceService) {

  }

  gender:Array<string>=["male","female"];
  signup_data:any;
  signupForm:FormGroup;
  user=JSON.parse(localStorage.getItem('loginUser'));
  ngOnInit(): void {
    this.signupForm=this.fb.group({
      name:[this.user.name,[Validators.required]],
      age:[this.user.age,[Validators.required]],
      gen:[this.user.gender,[Validators.required]],
      email:[this.user.email,[Validators.required,Validators.email]],
      username:[this.user.username,[Validators.required,Validators.minLength(8)]],
      password:[this.user.password,[Validators.required,Validators.minLength(8)]],
    });
  }
  public show:boolean = false;
  public buttonName:any = 'Update Your Profile';
  toggle() {
    this.show = !this.show;
    // CHANGE THE NAME OF THE BUTTON.
    if(this.show)
      this.buttonName = "Close";
    else
      this.buttonName = "Update Your Profile";
  }
  use:any;
  onsubmit(){

    console.log(this.signupForm.controls.username.value);
    this.use=JSON.parse(localStorage.getItem('loginUser'));
    this.signup_data={
      name:this.signupForm.controls.name.value,
      age:this.signupForm.controls.age.value,
      gen:this.signupForm.controls.gen.value,
      email:this.signupForm.controls.email.value,
      username:this.use.username,
      password:this.signupForm.controls.password.value
    }
    console.log(this.signup_data);

    this.serv.userUpdate(this.signup_data).subscribe(
    data=>{
      console.log(this.signup_data);
      this.signup_data=data;
      console.log(this.signup_data);
      localStorage.removeItem('loginUser');
      localStorage.setItem('loginUser',JSON.stringify(this.signup_data));
      alert("Your profile has been updated.");
      this.show = !this.show;
      // CHANGE THE NAME OF THE BUTTON.
      if(this.show)
        this.buttonName = "Close";
      else
        this.buttonName = "Update Your Profile";
    },
    error=>{
      console.log("ERROR");
    }
  );


  }

}
